import { Typography } from "@mui/material";
import photo from "../assets/HeadBack.webp";
import PageBanner from "./SectionPageBanner";

const HowItWorks = () => {
    return (
        <section style={{backgroundColor:'#fcfcfc'}}>
            <PageBanner image={photo} title="How It's Started" />
            <div className="px-4 py-5 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="text-center">
                    <Typography
                        variant="body1"
                        sx={{
                            mx: "30px",
                            mt: 4,
                            lineHeight: 1.75,
                            color: "#686868",
                            fontSize: "1.125rem",
                            fontFamily: "'Nunito', sans-serif",
                            textAlign: "justify"
                        }}
                    >
                        Our journey began with a simple idea — to create impactful tech solutions without external funding. As a bootstrapped venture, we grew with passion, persistence, and purpose. From launching our first product in 2021 to building a nationwide presence by 2025, every step has been a testament to our commitment and resilience.
                        <br /><br />
                        We’ve turned challenges into opportunities and ideas into real-world solutions. This is more than a timeline — it’s a story of growth, trust, and continuous evolution.
                        Here’s a glimpse of the milestones that shaped us.
                    </Typography>
                </div>

                <div className="relative mt-12 lg:mt-20">
                    <div className="absolute inset-x-0 hidden xl:px-44 top-2 md:block md:px-20 lg:px-28">
                        <img className="w-full" src="https://cdn.rareblocks.xyz/collection/celebration/images/steps/2/curved-dotted-line.svg" alt="" />
                    </div>

                    <div className="relative grid grid-cols-1 text-center gap-y-12 md:grid-cols-3 gap-x-12" >
                        <div>
                            <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                                <span className="text-xl font-semibold text-gray-700" style={{ fontFamily: "'Nunito', sans-serif" }}> 2021 </span>
                            </div>
                            <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10"> Foundation & Launch</h3>
                            <p className="mt-4 text-base text-gray-600" style={{ fontFamily: "'Nunito', sans-serif",fontSize: "1.125rem" }}>We registered our firm and launched our first product — the seed of what would become a powerful solution in the IT landscape. With limited resources and unlimited drive, our bootstrap journey officially began.</p>
                        </div>

                        <div>
                            <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                                <span className="text-xl font-semibold text-gray-700"> 2024 </span>
                            </div>
                            <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">A New Identity</h3>
                            <p className="mt-4 text-base text-gray-600" style={{ fontFamily: "'Nunito', sans-serif",fontSize: "1.125rem" }}>After years of growth and impact, we transitioned from a firm to a registered company. This milestone symbolized maturity, stability, and a deeper commitment to delivering value through technology.</p>
                        </div>

                        <div>
                            <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                                <span className="text-xl font-semibold text-gray-700"> 2025 </span>
                            </div>
                            <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">Impact at Scale</h3>
                            <p className="mt-4 text-base text-gray-600" style={{ fontFamily: "'Nunito', sans-serif",fontSize: "1.125rem" }}>We successfully completed 3 major projects and expanded our reach across India through our flagship product, Liter. Built with love and determination, Liter became a trusted digital companion for users nationwide.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HowItWorks;